import "./index.css";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline, makeStyles } from "@material-ui/core";
import { Provider } from "react-redux";

import store from "./store";

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline>
      <Provider store={store}>
        <Router>
          <App />
          <div id="body" />
        </Router>
      </Provider>
    </CssBaseline>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
